import{a as p}from"./chunk-7BKSRZNG.js";function i(...n){return o=>p(o,...n)}export{i as a};
